import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteEmployee: {
    employee: { id: string }
  }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.deleteEmployee.employee.id,
  name: 'Employee',
})

export default function remove(id: string): Promise<any> {
  return client.gql.mutate({ mutation, variables: { input: { id } } }).then(mutateHandler)
}

const mutation = gql`
  mutation DeleteEmployee($input: DeleteEmployeeMutationInput!) {
    deleteEmployee(input: $input) {
      employee {
        id
      }
    }
  }
`
